export interface IngestionButton {
  type: string;
  label: string;
  disableTypes: string[];
}

export const INGESTION_BUTTON_PROPS: IngestionButton[] = [
  { type: 'linear', label: 'Linear', disableTypes: ['linear', 'both'] }
];

export interface CompanyKpi {
  id: string;
}

export interface CompanyInfo {
  cid: string;
  name: string;
  agency?: string;
  KPIs: CompanyKpi[];
}

export interface BuildStatusRow {
  company_id: string;
  id: string;
  batch_job_name: string;
  batch_log_url?: string;
  status_batch: string;
  total_expected_runtime: number;
  now: string;
}

export type BuildStatusMap = Record<string, BuildStatusRow[]>;

// cid -> ingestion type -> whether that ingestion button is currently enabled
export type IngestStatusMap = Record<string, Record<string, boolean>>;

export interface KpiTableRow extends BuildStatusRow {
  company: string;
  kpi?: string;
}
